export default {
  dialcode: '593',
  phone: '93 992 7243',
  text: 'Quiero conocer más sobre la formación Official Agile Coach Training',
  url: 'https://api.whatsapp.com/send',
};
